export const passageConstants = {
  NEW_PASSAGE_REQUEST: "NEW_PASSAGE_REQUEST",
  NEW_PASSAGE_SUCCESS: "NEW_PASSAGE_SUCCESS",
  NEW_PASSAGE_FAILURE: "NEW_PASSAGE_FAILURE",

  GET_ALL_PASSAGES_REQUEST: "GET_ALL_PASSAGES_REQUEST",
  GET_ALL_PASSAGES_SUCCESS: "GET_ALL_PASSAGES_SUCCESS",
  GET_ALL_PASSAGES_FAILURE: "GET_ALL_PASSAGES_FAILURE",

  GET_PASSAGE_REQUEST: "GET_PASSAGE_REQUEST",
  GET_PASSAGE_SUCCESS: "GET_PASSAGE_SUCCESS",
  GET_PASSAGE_FAILURE: "GET_PASSAGE_FAILURE",

  UPDATE_PASSAGE_NODE_REQUEST: "UPDATE_PASSAGE_NODE_REQUEST",
  UPDATE_PASSAGE_NODE_SUCCESS: "UPDATE_PASSAGE_NODE_SUCCESS",
  UPDATE_PASSAGE_NODE_FAILURE: "UPDATE_PASSAGE_NODE_FAILURE",

  UPDATE_PASSAGE_TAG_REQUEST: "UPDATE_PASSAGE_TAG_REQUEST",
  UPDATE_PASSAGE_TAG_SUCCESS: "UPDATE_PASSAGE_TAG_SUCCESS",
  UPDATE_PASSAGE_TAG_FAILURE: "UPDATE_PASSAGE_TAG_FAILURE",

  UPDATE_PASSAGE_NODE_REQUEST: "UPDATE_PASSAGE_NODE_REQUEST",
  UPDATE_PASSAGE_NODE_SUCCESS: "UPDATE_PASSAGE_NODE_SUCCESS",
  UPDATE_PASSAGE_NODE_FAILURE: "UPDATE_PASSAGE_NODE_FAILURE",

  UPDATE_PASSAGE_CONTENT_REQUEST: "UPDATE_PASSAGE_CONTENT_REQUEST",
  UPDATE_PASSAGE_CONTENT_SUCCESS: "UPDATE_PASSAGE_CONTENT_SUCCESS",
  UPDATE_PASSAGE_CONTENT_FAILURE: "UPDATE_PASSAGE_CONTENT_FAILURE",

  DELETE_PASSAGE_REQUEST: "DELETE_PASSAGE_REQUEST",
  DELETE_PASSAGE_SUCCESS: "DELETE_PASSAGE_SUCCESS",
  DELETE_PASSAGE_FAILURE: "DELETE_PASSAGE_FAILURE",

  UPDATE_PASSAGE_NAME_REQUEST: "UPDATE_PASSAGE_NAME_REQUEST",
  UPDATE_PASSAGE_NAME_SUCCESS: "UPDATE_PASSAGE_NAME_SUCCESS",
  UPDATE_PASSAGE_NAME_FAILURE: "UPDATE_PASSAGE_NAME_FAILURE",

  UPDATE_PASSAGE_CODE_REQUEST: "UPDATE_PASSAGE_CODE_REQUEST",
  UPDATE_PASSAGE_CODE_SUCCESS: "UPDATE_PASSAGE_CODE_SUCCESS",
  UPDATE_PASSAGE_CODE_FAILURE: "UPDATE_PASSAGE_CODE_FAILURE"
}
